var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"view-page-not-found",attrs:{"limit":"small"}},[_c('blank-state',{attrs:{"title":"Page not found","description":"Looks like this page doesn't exist. 😕"}},[_c('click-button',{attrs:{"callback":_vm.backToHome}},[_vm._v("Back to home page")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4353750c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageNotFound.vue
// module id = 353
// module chunks = 0